export default "__VITE_ASSET__CtjgBZbY__"